const INITIAL_STATE = {
    order: {},
    orders: {
        hasNextPage: false,
        hasPreviousPage: false,
        indexFrom: 0,
        items: [],
        pageIndex: 0,
        pageSize: 10,
        totalCount: 0,
        totalPages: 0
    },
    filter:{
        orderCode: "",
        supplierCode: "",
        partNumber: "",
        statusPackList: []
    }

};

export default function packListReducer(state, action) {
    if (typeof state === 'undefined') {
        return INITIAL_STATE;
    }

    switch (action.type) {

        case 'SET_ORDERS':
            return {
                ...state,
                orders: action.orders,
            };

        case 'RESET_ORDERS':
            return {
                ...state,
                orders: INITIAL_STATE.orders
            };
        case 'LINE_PICKING_SELECT_ORDER':
            return {
                ...state,
                order: action.order,
            };
        case 'SET_FILTER':
            return {
                ...state,
                filter: action.filter,
            };
        case 'RESET_FILTER': {
            const filter = state.filter;
            filter.orderCode = undefined;
            filter.supplierCode = undefined;
            filter.partNumber = undefined;
            filter.statusPackList = [];
            return {
                ...state,
                filter
            };
        }
    
        default:
            return state;
    }
}
